import React from 'react';
import PropTypes from 'prop-types';
import { useTableThreeColumns } from '../hooks/useTableColumns';
import BaseTable from '../../../components/BaseTable/BaseTable';

const TableThree = ({ data, isLoading, error }) => {
  const columns = useTableThreeColumns();

  return <BaseTable data={data} columns={columns} isLoading={isLoading} error={error} />;
};

TableThree.propTypes = {
  data: PropTypes.arrayOf(PropTypes.object),
  isLoading: PropTypes.bool,
  error: PropTypes.oneOfType([PropTypes.string, PropTypes.object, PropTypes.bool]),
};

export default React.memo(TableThree);
